export function resolveRunForRoute(runs = [], routeId) {
  if (!routeId) return runs[0] || null;
  return runs.find((run) => run.id === routeId) || null;
}
